import Boton from "./Boton";
import "../Info.css"

const ETE = ()=>{
    return(
        <div className="infoalbum">
  <h1 className="title">NIGHTMARE: ESCAPE THE ERA</h1>
  <div className="infoal">
    <div className="infotext">
      <Boton/>
      <p className="ver">NORMAL (ver. Inside-Outside)</p>
      <p>-Photobook (cd+pb) = <span className="colordosa"> <span className="colorunoa">45usd</span> 40-50usd</span></p>
      <p>-Photocard = <span className="colordosa"> <span className="colorunoa">15usd</span> 15 usd</span></p>
      <p>-Photocard grupal = <span className="colordosa"> <span className="colorunoa">10usd</span> 5usd</span></p>
      <p>-Poster= <span className="colorunoa">3,75usd</span> </p> <span className="colordosa">5usd</span>
    </div>
    <img src="https://media.karousell.com/media/photos/products/2023/10/7/_wts__dreamcatcher_escape_the__1696651819_92ac62f4.jpg" alt="Album Cover" style={{ boxShadow: "3.5px 3.5px 0px rgb(26, 162, 172)" }}/>
    <img src="https://kpopcollectorsguide.weebly.com/uploads/2/9/1/9/29199653/dguiqvswaaacs0t_orig.jpg" alt="Album Cover" style={{ boxShadow: "3.5px 3.5px 0px rgb(26, 162, 172)" }}/>
  </div>
</div>

  )
}

export default ETE;